<template>
  <div>
    <template v-if="order">
      <ReturnShipmentForm @save="onSave" :order="order" :is-number-unique-error="isNumberUniqueError">
        <template v-slot:button>
          Создать
        </template>
      </ReturnShipmentForm>

      <v-dialog v-model="saveFailedDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 error--text"> Ошибка при обработке запроса на сервере</v-card-title>
          <v-card-text> {{ saveFailedDialogText }}</v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" text @click="saveFailedDialog = false">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <h3>Идет загрузка...</h3>
    </template>
  </div>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ReturnOrderService from "@/services/return.order.service";
import mappers from "@/helpers/mappers";
import ReturnShipmentService from "@/services/return.shipment.service";
import ReturnShipmentForm from "@/components/main/return-shipment/ReturnShipmentForm";

export default {
  name: "AddReturnShipmentView",
  components: {ReturnShipmentForm},
  data() {
    return {
      order: null,
      saveFailedDialogText: '',
      saveFailedDialog: false,
      isNumberUniqueError: false,
    }
  },
  methods: {
    loadOrder() {
      this.$store.dispatch(LAYOUT_LOADING_START);
      const id = +this.$route.params.orderId;
      ReturnOrderService.getInfo(id)
          .then(response => {
            this.order = mappers.mapReturnOrderInfo(response.data)
          })
          .catch(() => {
            this.$router.go(-1);
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
    onSave(data) {
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.isNumberUniqueError = false
      ReturnShipmentService.register(data)
          .then(response => {
            this.$router.push({name: 'return-shipment-page', params: {id: response.data.Id}});
          })
          .catch(exception => {
            if (exception.response && exception.response.data && exception.response.data.Message && exception.response.data.Message.Message) {
              this.saveFailedDialogText = exception.response.data.Message.Message
              this.saveFailedDialog = true

              this.isNumberUniqueError = exception.response.data.Message.Code === 102
            }
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    this.loadOrder()
  }
}
</script>